//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('user', ['userStatus']),

    ctaMessage() {
      switch (this.userStatus()) {
        case 'subscriber':
        case 'canceled':
          return 'View My Account'
        case 'user':
          return 'View Recommendations'
        default:
          return 'Get Started'
      }
    }
  }
}
